import React from "react";
import { motion } from "framer-motion";
import hervestlogo from "../../assets/images/hervest_splash.svg";

function SplashScreen() {
  return (
    <div className="bg-onboarding overflow-hidden w-screen h-screen backdrop-brightness-25 items-center bg-[#EFEAED] ">
      <div className="p-8 grid justify-items-center gap-y-8 ">
        <motion.div
          className="rounded-2xl mt-[60%] md:mt-[20%] p-10 w-full lg:w-[457px]"
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ duration: 0.5 }}
        >
          <a href="https://hervest.ng">
            <img loading="lazy" src={hervestlogo} alt="HerVest Logo"></img>
          </a>
        </motion.div>
      </div>
    </div>
  );
}

export default SplashScreen;
